<script lang="ts">
import { inject } from "vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: "Infotext",
  props: {
    name: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      default: "",
    },
    cssKlassen: {
      type: String,
      default: "",
    },
    hatSchliessenButton: {
      type: Boolean,
      default: false,
    },
    schliesstBeiKlickAufText: {
      //Einigen Hilfetexte enthalten Links. Um diese Klickbar zu erhalten, kann das Schließen der Hilfe
      //hierüber unterbunden werden.
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const istSichtbar: any = inject("istSichtbar");
    const wechsleSichtbarkeit: any = inject("wechsleSichtbarkeit");

    function klickAufText() {
      if (props.schliesstBeiKlickAufText) {
        wechsleSichtbarkeit(props.name);
      }
    }

    return {
      props,
      istSichtbar,
      wechsleSichtbarkeit,
      klickAufText,
    };
  },
});
</script>

<template>
  <div
    v-show="istSichtbar(props.name)"
    class="gev19__contexthelp-text"
    :class="props.cssKlassen"
    :style="{
      cursor: props.schliesstBeiKlickAufText === true ? 'pointer' : 'default',
    }"
    @click="klickAufText()"
  >
    <div
      v-if="props.hatSchliessenButton"
      class="gev19__contexthelp-close"
      title="Hilfe schließen"
      @click="wechsleSichtbarkeit(props.name)"
    ></div>
    <span v-html="props.text"></span>
    <slot></slot>
  </div>
</template>

<style scoped></style>
